export function computeSlopes(pts) {
  const slopes = []
  for (let i = 0; i < pts.length - 1; i++) {
    const dy = pts[i + 1].y - pts[i].y
    const dx = pts[i + 1].x - pts[i].x
    slopes.push(dx === 0 ? 0 : dy / dx)
  }
  return slopes
}

export function quantile(arr, p) {
  if (!arr.length) return 0
  const sorted = [...arr].sort((a, b) => a - b)
  const idx = (sorted.length - 1) * p
  const lo = Math.floor(idx),
    hi = Math.ceil(idx)
  if (lo === hi) return sorted[lo]
  return sorted[lo] + (sorted[hi] - sorted[lo]) * (idx - lo)
}

export function shouldLabelDynamic(pts, index, threshold) {
  const n = pts.length
  if (n === 0) return false
  if (index === 0 || index === n - 1) return true

  const slopes = computeSlopes(pts)
  const incoming = Math.abs(slopes[index - 1] || 0)
  const outgoing = Math.abs(slopes[index] || 0)
  return incoming >= threshold || outgoing >= threshold
}
